import { render, staticRenderFns } from "./OrganisationUserManagement.vue?vue&type=template&id=28460fb3"
import script from "./OrganisationUserManagement.vue?vue&type=script&lang=ts"
export * from "./OrganisationUserManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports